// extracted by mini-css-extract-plugin
export default {"main":"main_main__ks7t4","container":"main_container__FT6MR"};